var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{attrs:{"id":"example-1"}},_vm._l((_vm.fileInfoForm.items),function(item){return _c('li',{key:item},[_c('img',{attrs:{"src":item,"width":"90%","height":"90%"}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }